import {useSelector} from 'react-redux'
import {t} from '~/initializers/i18n'

export const useHasRole = role => {
	return useSelector(state => state.auth.user.role === role)
}

export const useRoleMessage = ({roles} = {}) => {
	const hasRole = useHasRole(roles)
	if (!roles || hasRole) return null
	return t(`role_message.missing_role.${roles}`)
}
